const storelocatorConstraints = {
  postalCode: {
    presence: {
      allowEmpty: false,
    },
  },
}

export default storelocatorConstraints
